import { render, staticRenderFns } from "./artistDetail.vue?vue&type=template&id=1f9580f5&scoped=true"
import script from "./artistDetail.vue?vue&type=script&lang=js"
export * from "./artistDetail.vue?vue&type=script&lang=js"
import style0 from "./artistDetail.vue?vue&type=style&index=0&id=1f9580f5&prod&scoped=true&lang=less"
import style1 from "@/assets/h5css/mobile/artistDetail.less?vue&type=style&index=1&id=1f9580f5&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9580f5",
  null
  
)

export default component.exports